module.exports = __webpack_public_path__ + "img/bladeCollection.229a00a4.png";